export enum ValueTypeEnum {
  none = 0,
  string = 1,
  int = 2,
  decimal = 3,
  date = 4,
  boolean = 5,
  profile = 6,
  SocialMedia = 7,
  Listing = 8,
  StringDropDown = 9,
  CustomField = 10,
  ProfileAddress = 11,
  HBAProfileData = 12,
  State = 13,
  MembershipLevel = 14,
  AffiliationChecklist = 15,
  UploadFile = 16,
  EmailOptIn = 20
}
